/**
 * Display helper shared by the payroll tab's pay-components card, the edit
 * form's read-only pay summary and the salary-history table.
 */
import { format_money } from '../../lib/format';
import type { MinorUnits } from '../../data/types';

/** The repo-wide "no value to show" glyph -- same one `toUiEmployee` writes for every absent employee field. */
export const NOT_CONFIGURED = '—';

/**
 * A pay figure, or `'—'` when it is zero.
 *
 * Zero is the "never configured" sentinel on BOTH pay bases, not a real
 * amount: `payroll.createEmployee` defaults `hourly_rate_cents` to 0, and
 * `toUiEmployee` collapses a null `monthly_salary_cents` to 0. The pay-run
 * store already reads it that way (`isNewJoinerUnconfigured` in
 * `wagepro_store_pay_runs.ts`), so printing a currency-formatted zero would
 * state a wage the employer never set (#24396).
 */
export function format_pay_amount(
  amount: MinorUnits,
  currency: string,
  locale: string,
): string {
  return amount === 0 ? NOT_CONFIGURED : format_money(amount, currency, locale);
}
